import BigNumber from 'bignumber.js'
import { ethers } from 'ethers'
import { Series } from 'state/types'
import { getAddress } from 'utils/addressHelpers'

export const mintNft = async (contract, amount, value) => {
  const amountBN = new BigNumber(amount).toString()

  const tx = await contract.mint(amountBN, {
    value: ethers.utils.parseEther(`${value}`),
  })
  const receipt = await tx.wait()
  return receipt.status
}

export const transferNft = async (contract, from, to, tokenId) => {
  const tx = await contract.transferFrom(from, to, tokenId)
  const receipt = await tx.wait()
  return receipt.status
}

export const approveNft = async (contract, to) => {
  const tx = await contract.setApprovalForAll(to, true)
  const receipt = await tx.wait()
  return receipt.status
}

export const stakeNft = async (contract, series: Series, tokenId) => {
  let tx = null
  if (series.withoutMC) {
    tx = await contract.stake(tokenId)
  } else {
    tx = await contract.stake(getAddress(series.address), tokenId)
  }
  const receipt = await tx.wait()
  return receipt.status
}

export const multiStakeNft = async (contract, series: Series, tokenIds) => {
  let tx = null
  if (series.withoutMC) {
    tx = await contract.batchStake(tokenIds)
  } else {
    tx = await contract.batchStake(getAddress(series.address), tokenIds)
  }
  const receipt = await tx.wait()
  return receipt.status
}

export const unstakeNft = async (contract, series: Series, tokenId) => {
  let tx = null
  if (series.withoutMC) {
    tx = await contract.unstake(tokenId)
  } else {
    tx = await contract.unstake(getAddress(series.address), tokenId)
  }
  const receipt = await tx.wait()
  return receipt.status
}

export const emergencyUnstakeNft = async (contract, series: Series, tokenId) => {
  if (series.withoutMC) {
    return contract.emergencyUnstake(tokenId)
  } else {
    return contract.emergencyUnstake(getAddress(series.address), tokenId)
  }
}

export const emergencyUnstakeAllNfts = async (contract, series: Series) => {
  if (series.withoutMC) {
    return null
  } else {
    return contract.emergencyUnstakeAll(getAddress(series.address))
  }
}

export const multiUnstakeNft = async (contract, series: Series, tokenIds) => {
  let tx = null
  if (series.withoutMC) {
    tx = await contract.batchUnstake(tokenIds)
  } else {
    tx = await contract.batchUnstake(getAddress(series.address), tokenIds)
  }
  const receipt = await tx.wait()
  return receipt.status
}

export const harvestNft = async (contract, series: Series) => {
  let tx = null
  if (series.withoutMC) {
    tx = await contract.harvest()
  } else {
    tx = await contract.harvest(getAddress(series.address))
  }
  const receipt = await tx.wait()
  return receipt.status
}

export const transferERC721IDS = async (contract, collectionAddress, toAddress, tokenIds) => {
  return contract.TransferERC721IDS(collectionAddress, toAddress, tokenIds)
}

export const multiTransferERC721 = async (contract, collectionAddress, toAddresses, tokenIds) => {
  return contract.multiTransferERC721(collectionAddress, toAddresses, tokenIds)
}

export const approveNftMultiTransfer = async (contract, address) => {
  return contract.setApprovalForAll(address, true)
}
